<app-page-header
  [pageTitle]="isEditMode ? 'Editar dirección' : 'Nueva dirección'"
  [showBreadcrumb]="true"
  [backRoute]="'../'"
  [backLabel]="'Direcciones'"
  [currentRoute]="isEditMode ? 'Editar' : 'Nueva'"
/>

@if (loadingData) {
  <app-spinner />
} @else {
  <app-card [title]="'Datos de la dirección'">
    <app-form [formGroup]="saveForm">
      <div class="grid grid-cols-1 gap-3 mb-5">
        <!-- Dirección -->
        <div>
          <app-label for="direccion">
            Dirección
          </app-label>
          <app-input-field id="direccion" type="text" formControlName="direccion" placeholder="Ingrese la dirección (Ej: Avenida Victoria)" />
          @if (saveForm.get('direccion')?.invalid && saveForm.get('direccion')?.touched) {
            <p class="text-error-500 text-sm mt-1">
              @if (saveForm.get('direccion')?.errors?.['required']) {
                La dirección es requerida
              }
              @if (saveForm.get('direccion')?.errors?.['minlength']) {
                La dirección debe tener al menos 3 caracteres
              }
            </p>
          }
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
          <!-- Latitud -->
          <div>
            <app-label for="latitud">
              Latitud
            </app-label>
            <app-input-field id="latitud" type="text" formControlName="latitud" placeholder="Ingrese la latitud (Ej: -25.2637)" />
            @if (saveForm.get('latitud')?.invalid && saveForm.get('latitud')?.touched) {
              <p class="text-error-500 text-sm mt-1">
                @if (saveForm.get('latitud')?.errors?.['required']) {
                  La latitud es requerida
                } @else {
                  Ingrese una latitud válida entre -90 y 90
                }
              </p>
            }
          </div>

          <!-- Longitud -->
          <div>
            <app-label for="longitud">
              Longitud
            </app-label>
            <app-input-field id="longitud" type="text" formControlName="longitud" placeholder="Ingrese la longitud (Ej: -57.5759)" />
            @if (saveForm.get('longitud')?.invalid && saveForm.get('longitud')?.touched) {
              <p class="text-error-500 text-sm mt-1">
                @if (saveForm.get('longitud')?.errors?.['required']) {
                  La longitud es requerida
                } @else {
                  Ingrese una longitud válida entre -180 y 180
                }
              </p>
            }
          </div>
        </div>

        <app-location-picker-trigger
          [latitud]="saveForm.get('latitud')?.value"
          [longitud]="saveForm.get('longitud')?.value"
          (coordinatesChange)="onCoordinatesChange($event)"
        />

        <div class="bg-blue-50 dark:bg-blue-900/20 p-3 rounded-md">
          <p class="text-sm text-blue-700 dark:text-blue-300">
            <strong>Nota:</strong> Las coordenadas de latitud y longitud se utilizan para ubicar
            geográficamente la dirección. Puede escribirlas manualmente o seleccionar el punto en el mapa.
          </p>
        </div>
      </div>
    </app-form>
  </app-card>

  @if (isEditMode) {
    <app-edition-buttons
      [process]="loading"
      [valid]="saveForm.valid"
      [editable]="false"
      (onUpdateClick)="saveDireccion()"
      (onCancelClick)="goBack()"
    />
  } @else {
    <app-creation-buttons
      [process]="loading"
      [valid]="saveForm.valid"
      (onCreateClick)="saveDireccion()"
      (onCancelClick)="goBack()"
    />
  }
}
